import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatDivider } from '@angular/material/divider';

@Component({
  selector: 'app-list-item-display',
  imports: [MatIconModule],
  templateUrl: './list-item-display.component.html',
  styleUrl: './list-item-display.component.less'
})
export class ListItemDisplayComponent {
  @Input() title: string = '';
  @Input() value: string = '';
  @Input() icon?: string;
  @Input() valueClass?: string = '';
  @Input() oldValue?: string = '';
  @Input() newValue?: string = '';
  @Input() showDiff: boolean = false;
  @Input() details?: string = '';
  @Input() oldDetails?: string = '';
  @Input() newDetails?: string = '';
  @Input() showModified: boolean = false;
  @Input() oldTitle?: string = '';
  @Input() newTitle?: string = '';
} 